import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { ProjectDetails } from "./ProjectDetails.tsx";
import theme from "./theme.tsx";
import { WorkDetails } from "./WorkDetails.tsx";
import { MusicDetails } from "./MusicDetails.tsx";
import { ContactDetails } from "./ContactDetails.tsx";
import { LaRecs } from "./LaRecs.tsx";
import { Analytics } from "@vercel/analytics/react";
import { NavItemProvider } from "./NavItemProvider.tsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "projects", element: <ProjectDetails /> },
      { path: "work", element: <WorkDetails /> },
      { path: "music", element: <MusicDetails /> },
      { path: "la-recs", element: <LaRecs /> },
      { path: "contact", element: <ContactDetails /> },
    ],
  },
  //redirect unrecognized routes to home
  {
    path: "*",
    element: <Navigate to="/" />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <NavItemProvider>
        <RouterProvider router={router} />
        <Analytics />
      </NavItemProvider>
    </ThemeProvider>
  </React.StrictMode>
);
